// extracted by mini-css-extract-plugin
export default {"Error404Wrapper":"Error404Wrapper_Error404Wrapper__qRYc5"};